<template>
  <header class="site-header">
    <div class="header-inner">
      <div class="brand" @click="goHome">
        <img class="logo-img" src="https://obs.huahuaeco.com/common/ic_huahua_banner.png" alt="化化" />
      </div>
      <nav class="main-nav">
        <router-link to="/" class="nav-link">首页</router-link>
        <div
          class="nav-dropdown"
          @mouseenter="openServiceMenu"
          @mouseleave="closeServiceMenu"
          :class="{ 'manual-active': $route.path.startsWith('/decorationServices') || $route.path.startsWith('/selfBuildServices') || showServiceMenu }"
        >
          <button type="button" class="nav-link nav-trigger">
            服务与解决方案
          </button>
          <div v-if="showServiceMenu" class="dropdown-menu">
            <router-link
              :to="{ path: '/decorationServices' }"
              class="dropdown-item"
              @click="closeServiceMenu"
            >
              装修服务
            </router-link>
            <router-link
              :to="{ path: '/selfBuildServices' }"
              class="dropdown-item"
              @click="closeServiceMenu"
            >
              自建房服务
            </router-link>
          </div>
        </div>
        <router-link to="/strategy" class="nav-link" :class="{ 'manual-active': $route.path.startsWith('/strategy') }">攻略</router-link>
        <router-link to="/case" class="nav-link" :class="{ 'manual-active': $route.path.startsWith('/case') }">案例</router-link>
        <router-link to="/settlein" class="nav-link">服务商入驻</router-link>
        <router-link to="/about" class="nav-link">关于我们</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      showServiceMenu: false
    }
  },
  methods: {
    openServiceMenu() {
      this.showServiceMenu = true
    },
    closeServiceMenu() {
      this.showServiceMenu = false
    },
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
.site-header{background:rgba(255,255,255,0.95);color:#0b1220;padding:12px 0;border-bottom:1px solid rgba(14,165,233,0.06);position:fixed;top:0;left:0;right:0;z-index:9999;backdrop-filter: blur(4px)}
.header-inner{max-width:var(--container-width);margin:0 auto;padding:0 16px;display:flex;align-items:center;justify-content:space-between}
.logo-img{height:38px;display:block}
.brand{cursor:pointer}
.main-nav{display:flex;gap:clamp(8px, 2.5vw, 28px);align-items:center;font-size:clamp(0px, 1.5vw, 16px);flex-wrap:nowrap;white-space:nowrap}
.nav-link{color:#374151;text-decoration:none;padding:8px 6px;border-radius:6px;position:relative;font-weight:500}
.nav-link:hover{color:#0b1220}
.nav-dropdown{position:relative;padding-bottom:14px;margin-bottom:-14px; }
.nav-trigger{border:0;background:transparent;cursor:pointer;font:inherit;font-size:clamp(10px, 1.5vw, 16px)}
.dropdown-menu{position:absolute;top:100%;left:50%;transform:translateX(-50%);min-width:136px;padding:8px;background:#fff;border:1px solid rgba(25,140,254,0.1);border-radius:10px;box-shadow:0 12px 28px rgba(15,23,42,0.12);display:flex;flex-direction:column;gap:4px}
.dropdown-menu::before{content:"";position:absolute;top:-6px;left:50%;transform:translateX(-50%) rotate(45deg);width:12px;height:12px;background:#fff;border-left:1px solid rgba(25,140,254,0.1);border-top:1px solid rgba(25,140,254,0.1)}
.dropdown-item{color:#374151;text-decoration:none;padding:10px 12px;border-radius:8px;font-size:clamp(11px, 1.3vw, 14px);line-height:1.4;white-space:nowrap}
.dropdown-item:hover{background:#f3f8ff;color:#198CFE}

.main-nav .router-link-active,
.main-nav .manual-active{color:#198CFE}
.main-nav .router-link-active::after,
.main-nav .manual-active::after{content:"";position:absolute;left:50%;transform:translateX(-50%);bottom:-8px;height:3px;width:36px;background:#198CFE;border-radius:3px}
.nav-dropdown.manual-active::after{bottom:6px}
</style>
